// Fallback station content — the backend event config (admin-editable) is the
// source of truth; this mirrors it so the page renders before the API responds.
const TBC = "TBC — awaiting organiser approval";

export const STATION_FALLBACKS = [
  { id: "burpee-broad-jumps", n: "01", name: "BURPEE BROAD JUMPS", tag: "FLOOR, THEN FORWARD" },
  { id: "kettlebell-farmers-carry", n: "02", name: "KETTLEBELL FARMER'S CARRY", tag: "GRIP VS. THE CLOCK" },
  { id: "sandbag-walking-lunges", n: "03", name: "SANDBAG WALKING LUNGES", tag: "LEGS ON TRIAL" },
  { id: "box-step-overs", n: "04", name: "BOX STEP-OVERS", tag: "UP AND OVER" },
  { id: "plate-squats", n: "05", name: "PLATE SQUATS", tag: "DEPTH OR NOTHING" },
  { id: "sandbag-ground-to-shoulder", n: "06", name: "SANDBAG GROUND-TO-SHOULDER", tag: "EARN THE SHOULDER" },
  { id: "push-up-sprint-finisher", n: "07", name: "PUSH-UP SPRINT FINISHER", tag: "EARN THE FINISH" },
];

export const RUN_DEFAULTS = { run_leg_meters: 700, run_legs: 8, total_km: "5.6", course_status: "provisional" };

export const DIVISION_COLUMNS = [
  ["men_solo", "MEN'S SOLO"],
  ["women_solo", "WOMEN'S SOLO"],
  ["men_doubles", "MEN'S DOUBLES"],
  ["women_doubles", "WOMEN'S DOUBLES"],
  ["mixed_doubles", "MIXED DOUBLES"],
];
export { TBC };
